import React, { useState } from 'react';
import { Drawer } from 'antd'; // Suponiendo que estás utiliz
import { map, isEmpty } from 'lodash';
import styled from 'styled-components';

const BaggingGallery = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    padding: 10px;
    text-align: center;
`;

const BaggingGalleryImg = styled.img`
    border-radius: 5px;
    width: 100%;
    height: 200px;
    object-fit: cover
`;

const NavButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0);
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
    z-index: 2001;
    font-size: 6rem;
`;

const LightboxContent = styled.div`
    max-width: 90%;
    max-height: 90%;
    overflow: hidden;
`;

const LightboxOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1001;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LightboxImage = styled.img`
    width: 100%;
    max-width: 600px;
    height: auto;
    display: block;
    margin: auto;
`;

const PrevButton = styled(NavButton)`
    left: 0px;
`;

const NextButton = styled(NavButton)`
    right: 0px;
`;

const BaggingImagesDrawer = ({ onClose, visible, images = [] }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    const openImage = (index) => {
        setSelectedImageIndex(index);
    };

    const closeImage = () => {
        setSelectedImageIndex(null);
    };

    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    const showPrevImage = () => {
        setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1));
    };

    const showNextImage = () => {
        setSelectedImageIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0));
    };

    return (
        <div>
            <Drawer
                width='700'
                title='Imágenes de embolsado'
                closable
                visible={visible}
                onClose={onClose}
            >
                <BaggingGallery>
                    {!isEmpty(images) ? (
                        map(images, (imageUrl, index) => (
                            <BaggingGalleryImg
                                key={index}
                                src={imageUrl}
                                onClick={() => openImage(index)}
                            />
                        ))
                    ) : <p>No hay imágenes disponibles.</p>}
                </BaggingGallery>
            </Drawer>

            {selectedImageIndex !== null && (
                <LightboxOverlay onClick={closeImage}>
                    <LightboxContent  onClick={handleContentClick}>
                        <PrevButton onClick={showPrevImage}>⟨</PrevButton>
                        <NextButton onClick={showNextImage}>⟩</NextButton>
                        <LightboxImage src={images[selectedImageIndex]} alt="Expanded Image" />
                    </LightboxContent>
                </LightboxOverlay>
            )}
        </div>
    );
};

export default BaggingImagesDrawer;